const DUTCH_IBAN_PATTERN = /^NL\d{2}[A-Z]{4}\d{10}$/;
// Mirrors Java's ASCII-only \s so a non-breaking space fails here exactly as it does in field-service.
const JAVA_WHITESPACE_PATTERN = /[ \t\n\v\f\r]/g;
const COUNTRY_AND_CHECK_DIGITS_LENGTH = 4;
const MOD_97 = 97;
const MOD_97_EXPECTED_REMAINDER = 1;
const LETTER_CHAR_CODE_OFFSET = 55;

export const IBAN_ERROR_KEYS = {
    invalidFormat: 'error.validation.field.iban.invalidFormat',
    invalidChecksum: 'error.validation.field.iban.invalidChecksum'
} as const;

type FieldValueValidator = (value: string | null | undefined) => string | null;

function getNormalizedIban(value: string): string {
    return value.replace(JAVA_WHITESPACE_PATTERN, '').toUpperCase();
}

function getIsMod97Valid(iban: string): boolean {
    const rearrangedIban = iban.slice(COUNTRY_AND_CHECK_DIGITS_LENGTH) + iban.slice(0, COUNTRY_AND_CHECK_DIGITS_LENGTH);
    const remainder = [...rearrangedIban].reduce((accumulator, character) => {
        const isLetter = character >= 'A' && character <= 'Z';
        return isLetter
            ? (accumulator * 100 + character.charCodeAt(0) - LETTER_CHAR_CODE_OFFSET) % MOD_97
            : (accumulator * 10 + Number(character)) % MOD_97;
    }, 0);
    return remainder === MOD_97_EXPECTED_REMAINDER;
}

/**
 * Value validators keyed by field-service validation type; each returns the backend message key, or null when valid.
 */
export const FIELD_VALUE_VALIDATORS: Record<string, FieldValueValidator> = {
    iban_nl: (value) => {
        const iban = getNormalizedIban(value ?? '');
        if (!DUTCH_IBAN_PATTERN.test(iban)) {
            return IBAN_ERROR_KEYS.invalidFormat;
        }
        if (!getIsMod97Valid(iban)) {
            return IBAN_ERROR_KEYS.invalidChecksum;
        }
        return null;
    }
};
